import { render, staticRenderFns } from "./NewReports.vue?vue&type=template&id=0a1a6950&scoped=true&"
import script from "./NewReports.vue?vue&type=script&lang=js&"
export * from "./NewReports.vue?vue&type=script&lang=js&"
import style0 from "./NewReports.vue?vue&type=style&index=0&id=0a1a6950&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1a6950",
  null
  
)

export default component.exports